import TagsInputViewV2 from './TagsInputView';

export default TagsInputViewV2;
